// Used to set application paramaters. This includes API Domains and Default Values

module.exports = global.config = {
    dashboard: {
        selectedInstance: "EA",
        range: 30,
        tooltips: true,
    },
    backend: {
      //baseURI: "https://localhost:7243",
      baseURI: "https://platformstatisticsapi.builtintelligence.com",
      //superTokensMiddleWare: "http://localhost:3001",
      superTokensMiddleWare: "https://passport.builtintelligence.com"
    }
}